import { isReadOnlySelector } from 'modules/MedComms/selectors';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ProjectPanel from 'components/ProjectPanel';
import { ProjectPanelActions, ProjectPanelSelectors } from 'components/ProjectPanel/models';
import { toggleUpdatedDocumentsDisplaying } from 'containers/App/actions';
import {
  showUpdatedImages,
  showUpdatedModuleBundles,
  showUpdatedReferences,
  showUpdatedReusableLayouts,
  showUpdatedStoryCards,
  showUpdatedTextCollections,
} from 'containers/App/selectors';
import {
  groupLayoutDocumentsForAssetsPanel,
  reusableLayoutDocumentsForAssetsPanel,
  updatedInPromoMatsEntities,
} from 'containers/Documents/selectors';
import { setActiveTab, setContentFilter, toggleSection } from 'containers/ProjectPanel/actions';
import {
  activeSections,
  activeTab,
  availableFilters,
  citations,
  images,
  moduleBundles,
  reusableLayouts,
  storyCardsAndMagicForms,
  textCollections,
  textComponents,
} from 'containers/ProjectPanel/selectors';

const mapStateToProps = createStructuredSelector({
  activeSections,
  activeTab,
  availableFilters,
  citations,
  groupLayoutDocuments: groupLayoutDocumentsForAssetsPanel,
  images,
  moduleBundles,
  reusableLayouts,
  reusableLayoutDocuments: reusableLayoutDocumentsForAssetsPanel,
  showUpdatedImages,
  showUpdatedModuleBundles,
  showUpdatedReferences,
  showUpdatedReusableLayouts,
  showUpdatedStoryCards,
  showUpdatedTextCollections,
  storyCardsAndMagicForms,
  textCollections,
  textComponents,
  updatedInPromoMatsEntities,
  isReadOnly: isReadOnlySelector,
});

const mapDispatchToProps = {
  setActiveTab,
  toggleSection,
  setContentFilter,
  toggleUpdatedDocumentsDisplaying,
};

export default connect<ProjectPanelSelectors, ProjectPanelActions>(mapStateToProps, mapDispatchToProps)(ProjectPanel);
